import { getMatches } from '@/utils/statScoreApi';
import groupBy from 'lodash/groupBy';

const defaultState = {
  matches: { loading: false, data: [] },
  matchFixtures: {},
  matchResults: {},
};
const state = {
  ...JSON.parse(JSON.stringify(defaultState)),
};

const getters = {};

const mutations = {
  setLoadingStatus(state, data) {
    state.matches = data.status
      ? { loading: data.status, data: [], error: data.error }
      : { ...state.matches, loading: false, error: data.error };
  },
  setDefaultState(state) {
    Object.keys(defaultState).forEach(key => {
      state[key] = defaultState[key];
    });
  },
  setMatchFixtures(state, data) {
    state.matchFixtures = data;
  },
  setMatchResults(state, data) {
    state.matchResults = data;
  },
};

const actions = {
  getMatches: ({ commit, rootState }, payload) => {
    commit('setDefaultState');
    commit('setLoadingStatus', { status: true });
    return getMatches({
      selectedLang: rootState.settings.selectedLocale.short_code,
      id: payload,
    })
      .then(res => {
        let matchFixtures = [];
        res.data.Data.MatchFixtures.forEach(fixtures => {
          matchFixtures = [...matchFixtures, ...fixtures.seasons[0].stages[0].Groups[0].events];
        });
        let FixturesGroupedByRound = groupBy(matchFixtures, n => {
          return n.round_name;
        });
        let slicedObject = {};
        FixturesGroupedByRound = Object.keys(FixturesGroupedByRound)
          .slice(0, 3)
          .forEach(function(v, i) {
            slicedObject = { ...slicedObject, [v]: FixturesGroupedByRound[v] };
          });

        commit('setMatchFixtures', slicedObject);

        let matchResults = [];
        res.data.Data.MatchResults.forEach(results => {
          matchResults = [...matchResults, ...results.seasons[0].stages[0].Groups[0].events];
        });

        let ResultsGroupedByRound = groupBy(matchResults, n => {
          return n.round_name;
        });

        let sortedObject = {};
        Object.keys(ResultsGroupedByRound)
          .sort(function(a, b) {
            return ('' + a.attr).localeCompare(b.attr);
          })
          .slice(0, 3)
          .forEach(function(v, i) {
            sortedObject = { ...sortedObject, [v]: ResultsGroupedByRound[v] };
          });
        commit('setMatchResults', sortedObject);
        commit('setLoadingStatus', { status: false });
      })
      .catch(err => {
        //console.log(err);
        commit('setLoadingStatus', { status: false, error: true });
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
